import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const lineVar = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, ease, delay: i * 0.12 } }),
};

// Masked line-by-line reveal. onLoad=true animates on mount (hero), else on scroll.
export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, delay = 0, as = "h2", ...rest }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Tag className={className} initial="hidden" {...trigger} {...rest}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className={`block ${lineClassName}`} variants={lineVar} custom={i + delay / 0.12}>
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-[#D4AF37]/60" />
    {children}
  </p>
);
